module.exports = __webpack_public_path__ + "img/lk.0f822557.svg";